import React from 'react';
import { useTranslation } from 'react-i18next';

import LanguageIcon from '@mui/icons-material/Language';
import LogoutIcon from '@mui/icons-material/Logout';
import { IconButton, Menu, MenuItem, Box, useMediaQuery, useTheme, Button } from '@mui/material';

import { useLogout } from './Menu/menu.actions';
import { getFlagForLanguage } from '../../utils/flag-utils';

import styles from './header.module.scss';
import RetryImg from '@shared/components/RetryImg';

interface HeaderProps {
  gameKey?: string;
}

const Header: React.FC<HeaderProps> = ({ gameKey }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [langMenuAnchor, setLangMenuAnchor] = React.useState<null | HTMLElement>(null);
  const [, handleLogout, logoutLoading] = useLogout();

  const handleLangClick = (event: React.MouseEvent<HTMLElement>) => {
    setLangMenuAnchor(event.currentTarget);
  };
  const handleLangClose = () => {
    setLangMenuAnchor(null);
  };
  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng);
    handleLangClose();
  };

  const handleLogoutButtonClick = () => {
    handleLogout();
  };

  const handleFaviconClick = () => {
    window.open('https://gameinvitation.com', '_blank');
  };

  return (
    <header className={styles.header}>
      <div className={styles.left}>
          <IconButton 
            onClick={handleFaviconClick}
            className={styles.faviconBtn}
            sx={{ 
              padding: '4px',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <RetryImg 
              src="/favicon.ico" 
              alt="GameInvitation" 
              style={{ 
                width: '24px', 
                height: '24px',
                cursor: 'pointer'
              }} 
            />
          </IconButton>
                 {!isMobile && (
           <span 
             onClick={handleFaviconClick}
             className={styles.logoLabel}
           >
             GameInvitation.com
           </span>
        )}
      </div>
      <div className={styles.center}>
        {isMobile && gameKey ? (
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              fontSize: '0.7rem',
              fontWeight: 500,
              color: 'text.primary',
              textAlign: 'center',
              whiteSpace: 'nowrap'
            }}
          >
            {gameKey}
          </Box>
        ) : (
          <>
            <span className={styles.langText}>{t('global.language')}</span>
            <IconButton 
              onClick={handleLangClick} 
              className={`${styles.langBtn} ${styles.textFlag}`}
            >
              {getFlagForLanguage(i18n.language)}
            </IconButton>
          </>
        )}
        <Menu
          anchorEl={langMenuAnchor}
          open={Boolean(langMenuAnchor)}
          onClose={handleLangClose}
        >
          <MenuItem onClick={() => handleLanguageChange('en-EN')}>{t('global.languages.en')}</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('ru-RU')}>{t('global.languages.ru')}</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('es-ES')}>{t('global.languages.es')}</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('de-DE')}>{t('global.languages.de')}</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('fr-FR')}>{t('global.languages.fr')}</MenuItem>
        </Menu>
      </div>
      <div className={styles.right}>
        {!isMobile && gameKey && <span className={styles.gameKey}>{gameKey}</span>}
        {isMobile && (
          <IconButton 
            onClick={handleLangClick} 
            className={`${styles.langBtn} ${styles.textFlag}`}
          >
            {getFlagForLanguage(i18n.language)}
          </IconButton>
        )}
        {/* Кнопка LOGOUT вместо ключа */}
        {!isMobile ? (
          <Button
            onClick={handleLogoutButtonClick}
            disabled={logoutLoading}
            variant="outlined"
            size="small"
            startIcon={<LogoutIcon />}
            sx={{
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#666',
              borderColor: '#ddd',
              '&:hover': {
                borderColor: '#999',
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            {t('global.LOGOUT')}
          </Button>
        ) : (
          <IconButton
            onClick={handleLogoutButtonClick}
            disabled={logoutLoading}
            size="small"
            sx={{
              color: '#666',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            <LogoutIcon />
          </IconButton>
        )}
      </div>
    </header>
  );
};

export default Header; 